module.exports = __webpack_public_path__ + "static/img/box.5b9dc60f.svg";